export default __webpack_public_path__ + "static/media/logo-color.1d863784.png";